import { SelectButtonDesignTokens } from '@primeuix/themes/types/selectbutton';

export const SELECT_BUTTON_STYLES: SelectButtonDesignTokens = {
  css: ({ dt }) => `
    .p-selectbutton .p-togglebutton-label {
        font-weight: 400;
        text-wrap: nowrap;
    }

    .p-selectbutton .p-togglebutton-content {
        padding: 0.1875rem 0.375rem !important;
    }

    .p-selectbutton .p-togglebutton.p-togglebutton-checked {
        color: ${dt('primary.500')};
    }`,
};
